// THEME FILES
// -----------------------------------------------------------------------------

// VENDOR FILES
// -----------------------------------------------------------------------------

// CUSTOM CODE
// -----------------------------------------------------------------------------


const mobileCloseButton = document.querySelector('.head-nav-mobile-close');
const mobileToggleButton = document.querySelector('.nav-mobile-toggle');

if ( mobileCloseButton ) {
    mobileCloseButton.addEventListener('click', function() {
        document.body.classList.remove('header-nav-mobile-expanded');
    });
}

if ( mobileToggleButton ) {
    mobileToggleButton.addEventListener('click', function() {
        document.body.classList.add('header-nav-mobile-expanded');
    });
}

const searchOpenBtnDesktop = document.querySelector('.search-nav-icon-desktop');
const searchParent = document.querySelector('.search-header');
const searchInput = document.querySelector('.search-header-input-field');

function toggleSearch(event, focusInput = false) {
    event.stopPropagation();
    const isOpening = !searchParent.classList.contains('search-header-search-open');
    searchParent.classList.toggle('search-header-search-open');

    // If opening the search and focusInput is true, focus the input field
    if (isOpening && focusInput && searchInput) {
        // Use setTimeout to ensure the element is visible before focusing
        setTimeout(() => {
            searchInput.focus();
        }, 50);
    }
}

if ( searchOpenBtnDesktop && searchParent ) {
    searchOpenBtnDesktop.addEventListener('click', function(event) {
        toggleSearch(event);
    });

    searchOpenBtnDesktop.addEventListener('keydown', function(event) {
        // Handle Enter and Space keys for accessibility
        if ( event.key === 'Enter' || event.key === ' ' ) {
            event.preventDefault(); // Prevent space from scrolling the page
            toggleSearch(event, true); // Pass true to focus the input when opened via keyboard
        }
    });

    document.addEventListener('click', function(event) {
        if ( ! searchParent.contains(event.target) && searchParent.classList.contains('search-header-search-open') ) {
            searchParent.classList.remove('search-header-search-open');
        }
    });
}


// Get away button
function getAway() {
    // Get away right now
    window.open('https://weather.com', '_newtab');
    // Replace current site with another benign site
    window.location.replace('https://www.google.com/search?q=weather%20channel');
    // Clear the history
    window.history.pushState(null, null, '/');
}

document.addEventListener('DOMContentLoaded', function() {
    const getAwayButton = document.querySelector('#get-away');
    const getAwayHelp = document.querySelector('#get-away-help');

    if (getAwayButton) {
        getAwayButton.addEventListener('click', function(e) {
            getAway();
        });

        const getAwayLink = getAwayButton.querySelector('a');
        if (getAwayLink) {
            getAwayLink.addEventListener('click', function(e) {
                // allow the (?) link to work
                e.stopPropagation();
                getAwayHelp.style.display = 'block';
            });
        }
    }

    if (getAwayHelp) {
        getAwayHelp.addEventListener('click', function(e) {
            getAwayHelp.style.display = 'none';
        });
    }

    document.addEventListener('keyup', function(e) {
        if (e.key === 'Escape') { // escape key
            getAway();
        }
    });
});

// LEADERSHIP BIOS
document.addEventListener('DOMContentLoaded', function() {
    function initBehavior() {
        const infoAreas = document.querySelectorAll('.bio-content');
        const images = document.querySelectorAll('.pattern-bio .wp-block-pacecore-blocks-anchor-group');

        infoAreas.forEach(area => {
            area.style.display = 'none';
            area.classList.remove('visible');
        });

        images.forEach(image => {
            const figure = image.querySelector('figure');

            image.addEventListener('click', function(event) {
                event.preventDefault();

                const currentInfo = image.nextElementSibling;
                const currentlyVisible = document.querySelector('.bio-content.visible');

                if (currentlyVisible && currentlyVisible !== currentInfo) {
                    currentlyVisible.classList.remove('visible');
                    currentlyVisible.style.display = 'none';
                    currentlyVisible.previousElementSibling.querySelector('figure').classList.remove('info-visible');
                }

                if (currentInfo.style.display === 'none') {
                    currentInfo.style.display = 'flex';
                    currentInfo.classList.add('visible');
                    figure.classList.add('info-visible');
                } else {
                    currentInfo.classList.remove('visible');
                    currentInfo.style.display = 'none';
                    figure.classList.remove('info-visible');
                }
            });
        });

        infoAreas.forEach(area => {
            area.addEventListener('click', function(event) {
                if (event.target === area) {
                    area.classList.remove('visible');
                    area.style.display = 'none';
                    const anchor = area.previousElementSibling.querySelector('figure');
                    anchor.classList.remove('info-visible');
                }
            });
        });
    }

    function handleResize() {
        const isCurrentlyMobile = window.innerWidth <= 991;
        let openSections = [];

        if (isCurrentlyMobile !== (window.innerWidth <= 991)) {
            const infoAreas = document.querySelectorAll('.bio-content');

            infoAreas.forEach(area => {
                if (area.classList.contains('visible')) {
                    openSections.push(area);
                }
                area.classList.remove('visible');
                area.style.display = 'none';
            });

            initBehavior();

            openSections.forEach(section => {
                section.style.display = 'flex';
                section.classList.add('visible');
                const anchor = section.previousElementSibling.querySelector('figure');
                anchor.classList.add('info-visible');
            });
        }
    }

    initBehavior();

    window.addEventListener('resize', handleResize);
});

function adjustElementHeights() {

    const elements = document.querySelectorAll('.card-info');

    elements.forEach(function(element) {
        element.style.height = 'auto';
    });

    let maxHeight = 0;
    elements.forEach(function(element) {
        const elementHeight = element.scrollHeight;
        if (elementHeight > maxHeight) {
            maxHeight = elementHeight;
        }
    });

    elements.forEach(function(element) {
        element.style.height = maxHeight + 'px';
    });
}

window.addEventListener('load', function() {
    setTimeout(adjustElementHeights, 100);
});

let resizeTimeout;
window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(adjustElementHeights, 200);
});
